import { render } from "./HomeModalShare.vue?vue&type=template&id=836bf14e&scoped=true"
import script from "./HomeModalShare.vue?vue&type=script&lang=js"
export * from "./HomeModalShare.vue?vue&type=script&lang=js"

import "./HomeModalShare.vue?vue&type=style&index=0&id=836bf14e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-836bf14e"

export default script